module.exports = __webpack_public_path__ + "static/vf_wcoats_core.2235bc3a.svg";